<div class="field-wrapper d-flex align-items-end" [ngStyle]="fieldStyle" (click)="showAddInitials()">
  <span class="field-placeholder" *ngIf="!field.value">
    <i class="cs-icon cs-icon-initial ml-1"></i>
    <ng-container i18n>Click here to initial</ng-container><i class="text-danger" *ngIf="field.required">*</i>
  </span>
  <img [src]="field.value" alt="initials" *ngIf="field.value" [ngStyle]="signatureStyle" />
</div>
